/**
 * Правила доступа к разделу план/факт.
 *
 * По умолчанию раздел открыт только администраторам. Для магазинов из
 * allowlist любой пользователь с доступом к магазину (владелец/сотрудник)
 * может смотреть таблицу — доступ к самому магазину проверяется layout'ом.
 */

/** Shop/brandshop ID, для которых план/факт открыт всем с доступом к магазину. */
export const PLAN_FACT_OPEN_SHOP_IDS = new Set<string>([
  // Kulberries ОПТИМА (brandshop)
  // В URL и /users/me/shops используется brandshop_id (_id документа):
  '6a0c56af758b76aef4099fb5',
  // shop_id родительского bigshop (для обратной совместимости и ручных ссылок):
  '69805c8090ac4f1b5a860f9c',
])

/**
 * Проверяет, можно ли показывать раздел план/факт для магазина.
 *
 * Args:
 *   shopId: Идентификатор магазина из URL (shop.id или brandshop.id).
 *   options.isAdmin: Пользователь с ролью admin.
 *   options.alternateShopIds: Дополнительные id для проверки (например shop_id brandshop).
 *
 * Returns:
 *   true, если раздел доступен; иначе false.
 */
export function canAccessPlanFact(
  shopId: string | null | undefined,
  options: { isAdmin?: boolean; alternateShopIds?: string[] } = {},
): boolean {
  if (options.isAdmin) return true

  const candidateIds = [shopId, ...(options.alternateShopIds ?? [])].filter(
    (value): value is string => Boolean(value),
  )

  return candidateIds.some((id) => PLAN_FACT_OPEN_SHOP_IDS.has(id))
}
